'use es6';

import { combineReducers } from 'redux';
import SeamlessImmutable from 'seamless-immutable';
import { isEqual } from 'underscore';
import { VALIDATE_TEMPLATE, VALIDATE_LAYOUT } from 'DesignData/actions/ActionTypes';

function templateErrorsById(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case VALIDATE_TEMPLATE:
      {
        const {
          assetId,
          renderingErrors
        } = action;

        if (renderingErrors && assetId) {
          return state.set(assetId, SeamlessImmutable(renderingErrors));
        }

        return state;
      }

    default:
      return state;
  }
}

const EMPTY_LAYOUT_ERROR_STATE = SeamlessImmutable({
  head: SeamlessImmutable([]),
  footer: SeamlessImmutable([]),
  widgets: SeamlessImmutable({})
});
/**
 * Stopgap until back end validation becomes better. Putting widget errors in for now
 * but only using header/footer errors.
 */

function layoutErrorsById(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case VALIDATE_LAYOUT:
      {
        const {
          renderingErrors,
          layoutId,
          isHead,
          isFooter,
          widgetId,
          widgetField
        } = action;

        if (!(renderingErrors && layoutId)) {
          return state;
        }

        const errors = state[layoutId] || EMPTY_LAYOUT_ERROR_STATE;

        if (isHead) {
          if (isEqual(renderingErrors, errors.head)) {
            return state;
          }

          const newState = errors.set('head', renderingErrors);
          return state.set(layoutId, newState);
        }

        if (isFooter) {
          if (isEqual(renderingErrors, errors.footer)) {
            return state;
          }

          const newState = errors.set('footer', renderingErrors);
          return state.set(layoutId, newState);
        }

        if (widgetId) {
          /* Add support for errors in nested fields */
          const widgetFieldKey = Array.isArray(widgetField) ? widgetField.join('-') : widgetField;
          const oldRenderingErrors = errors.widgets.getIn([widgetId, widgetFieldKey]);

          if (isEqual(renderingErrors, oldRenderingErrors)) {
            return state;
          }

          const newState = errors.widgets.setIn([widgetId, widgetFieldKey], renderingErrors);
          return state.setIn([layoutId, 'widgets'], newState);
        }

        return state;
      }

    default:
      return state;
  }
}

export default combineReducers({
  templateErrorsById,
  layoutErrorsById
});